package com.mgacreative.hotel

import org.koin.core.module.Module
import org.koin.dsl.module
import com.mgacreative.hotel.shared.ui.designsystem.di.getCommonAppModule
import com.mgacreative.hotel.domain.di.getDomainModule
import com.mgacreative.hotel.feature.admin.di.getAdminFeatureModule
import com.mgacreative.hotel.feature.hotel.di.getHotelFeatureModule
import com.mgacreative.hotel.feature.reservation.di.getReservationFeatureModule
import com.mgacreative.hotel.feature.room.di.getRoomFeatureModule
import com.mgacreative.hotel.feature.reports.di.getReportsFeatureModule
import com.mgacreative.hotel.feature.staff.di.getStaffFeatureModule
import com.mgacreative.hotel.feature.housekeeping.di.getHousekeepingFeatureModule
import com.mgacreative.hotel.feature.finance.di.getFinanceFeatureModule
import com.mgacreative.hotel.feature.inventory.di.getInventoryFeatureModule
import com.mgacreative.hotel.feature.maintenance.di.getMaintenanceFeatureModule
import com.mgacreative.hotel.feature.pricing.di.getPricingFeatureModule
import com.mgacreative.hotel.feature.restaurant.di.getRestaurantFeatureModule
import com.mgacreative.hotel.feature.channelmanager.di.getChannelManagerFeatureModule
import com.mgacreative.hotel.feature.ai_assistant.di.getAiAssistantFeatureModule
import com.mgacreative.hotel.feature.crm.di.getCrmFeatureModule
import com.mgacreative.hotel.feature.guestapp.di.getGuestAppFeatureModule

val webModule = module {
    // Web platformu icin boş PDF servisi saglıyoruz
    single<com.mgacreative.hotel.feature.inventory.export.PdfExporter> {
        object : com.mgacreative.hotel.feature.inventory.export.PdfExporter {
            override fun exportSupplierOrdersToPdf(
                supplierName: String,
                orders: List<com.mgacreative.hotel.domain.repository.PurchaseOrder>,
                items: List<com.mgacreative.hotel.domain.repository.PurchaseOrderItem>
            ) {
                // Web'de desteklenmiyor
            }
        }
    }
}

fun getWebAppModules(): List<Module> = listOf(
    getCommonAppModule(),
    getDomainModule(),
    getAdminFeatureModule(),
    getHotelFeatureModule(),
    getReservationFeatureModule(),
    getRoomFeatureModule(),
    getReportsFeatureModule(),
    getStaffFeatureModule(),
    getHousekeepingFeatureModule(),
    getFinanceFeatureModule(),
    getInventoryFeatureModule(),
    getMaintenanceFeatureModule(),
    getPricingFeatureModule(),
    getRestaurantFeatureModule(),
    getChannelManagerFeatureModule(),
    getAiAssistantFeatureModule(),
    getCrmFeatureModule(),
    getGuestAppFeatureModule(),
    webModule
)
